import { SvgIcon } from "@progress/kendo-react-common";
import { sortAscSmallIcon, sortDescSmallIcon } from "@progress/kendo-svg-icons";
import clsx from "clsx";

import type { MouseEvent, ReactNode } from "react";
import type { SortDescriptor } from "@progress/kendo-data-query";
import type { SvgIconProps } from "@progress/kendo-react-common";

export interface SortableColumnHeaderProps {
  className?: string;
  direction?: SortDescriptor["dir"];
  field: string;
  iconClassName?: string;
  iconSize?: SvgIconProps["size"];
  inactiveIconClassName?: string;
  label: ReactNode;
  onSort: (field: string) => void;
  showInactiveIcon?: boolean;
  sortable?: boolean;
  testId?: string;
}

export const SortableColumnHeader = ({
  className,
  direction,
  field,
  iconClassName,
  iconSize,
  inactiveIconClassName,
  label,
  onSort,
  showInactiveIcon = false,
  sortable = true,
  testId,
}: SortableColumnHeaderProps) => {
  const visibleDirection = direction ?? (showInactiveIcon ? "asc" : undefined);
  let icon;
  if (visibleDirection === "desc") {
    icon = sortDescSmallIcon;
  } else if (visibleDirection === "asc") {
    icon = sortAscSmallIcon;
  }

  const preventPopupClose = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  if (!sortable) {
    return (
      <div className={className} data-testid={testId} onMouseDown={preventPopupClose}>
        {label}
      </div>
    );
  }

  const handleSort = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    event.preventDefault();
    onSort(field);
  };

  return (
    <div
      className={className}
      data-testid={testId}
      onClick={handleSort}
      onMouseDown={preventPopupClose}
    >
      {label}
      {icon && (
        <span className={clsx(iconClassName, !direction && inactiveIconClassName)}>
          <SvgIcon icon={icon} size={iconSize} />
        </span>
      )}
    </div>
  );
};
